import React, { memo } from "react";
import { cn } from "utils";
import { ResultItemProps } from "./types";
import NextImage from "@/src/components/NextImage";

export const ResultItem: React.FC<ResultItemProps> = memo((props) => {
  const { item, className, onClick } = props;
  const { asset_name, asset_symbol, asset_logo } = item;
  return (
    <div
      data-openreplay-label="Search · ResultItem · div"
      className={cn(
        "flex items-center gap-2 md:px-2 px-0 md:py-2 py-4 rounded-1.5",
        "md:hover:bg-background_white_overlay5",
        className,
      )}
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      <div className="w-6 h-6 rounded-full bg-background_white_overlay10 flex items-center justify-center overflow-hidden">
        <NextImage
          src={asset_logo || ""}
          alt={asset_symbol || asset_name || ""}
          className="w-full h-full object-cover"
          width={24}
          height={24}
        />
      </div>
      <div className="flex-1 min-w-0 flex flex-row items-center gap-[2px]">
        <div className="body_medium_m text-content_primary">
          {asset_symbol || ""}
        </div>
        {asset_symbol && (
          <div className="body_s text-content_tertiary truncate">
            {asset_name || asset_symbol || ""}
          </div>
        )}
      </div>
    </div>
  );
});

ResultItem.displayName = "ResultItem";
